module.exports = __webpack_public_path__ + "img/loginform-psd.c879153d.svg";